import { render, staticRenderFns } from "./bot-response-button-message.vue?vue&type=template&id=5db5f936&"
import script from "./bot-response-button-message.vue?vue&type=script&lang=js&"
export * from "./bot-response-button-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports